import { RouteConfig } from 'vue-router'

/**
 * Helper function to create a route config
 * @param path
 * @param name
 */
export function route(path: string, name: string): RouteConfig {
  const component = (): Promise<typeof import('*.vue')> => import(`../${name}.vue`)
  return { path, name, component }
}
